import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M20 18L14 18L14 6L20 6L20 18Z" fill="currentColor" stroke="none" />
		<Path d="M4 9.25H11M11 14.75H4" vectorEffect="non-scaling-stroke" />
	</SVG>
);
